// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vault_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { SyncUpdate } from "./sync_update_pb";
import { file_sync_update } from "./sync_update_pb";
import type { VaultProfileLock } from "./locks_pb";
import { file_locks } from "./locks_pb";
import type { VaultMemberSyncMode } from "./vault_member_sync_mode_pb";
import { file_vault_member_sync_mode } from "./vault_member_sync_mode_pb";
import type { VaultMessageType } from "./vault_message_type_pb";
import { file_vault_message_type } from "./vault_message_type_pb";
import type { VaultPermissionLevel } from "./vault_permission_level_pb";
import { file_vault_permission_level } from "./vault_permission_level_pb";
import type { LoginMaintenanceCriteria } from "./login_maintenance_criteria_pb";
import { file_login_maintenance_criteria } from "./login_maintenance_criteria_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vault_service.proto.
 */
export const file_vault_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_sync_update, file_locks, file_vault_member_sync_mode, file_vault_message_type, file_vault_permission_level, file_login_maintenance_criteria, file_google_protobuf_wrappers, file_google_protobuf_timestamp]);

/**
 * @generated from message domain.UpdateMessage
 */
export type UpdateMessage = Message<"domain.UpdateMessage"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;

  /**
   * @generated from field: string generation_id = 2;
   */
  generationId: string;

  /**
   * @generated from field: domain.VaultMessageType type = 3;
   */
  type: VaultMessageType;

  /**
   * @generated from field: bytes encrypted_data = 4;
   */
  encryptedData: Uint8Array;
};

/**
 * Describes the message domain.UpdateMessage.
 * Use `create(UpdateMessageSchema)` to create a new message.
 */
export const UpdateMessageSchema: GenMessage<UpdateMessage> = /*@__PURE__*/
  messageDesc(file_vault_service, 0);

/**
 * @generated from message domain.VaultRegenerateData
 */
export type VaultRegenerateData = Message<"domain.VaultRegenerateData"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string latest_commit_id = 2;
   */
  latestCommitId: string;

  /**
   * @generated from field: repeated domain.VaultProfileLock profile_locks = 7;
   */
  profileLocks: VaultProfileLock[];

  /**
   * @generated from field: bytes squashed_commits = 5;
   */
  squashedCommits: Uint8Array;

  /**
   * @generated from field: bytes message_public_key = 8;
   */
  messagePublicKey: Uint8Array;

  /**
   * @generated from field: repeated string delete_message_ids = 9;
   */
  deleteMessageIds: string[];

  /**
   * @generated from field: repeated domain.VaultRegenerateData.RegeneratedMessage regenerated_messages = 11;
   */
  regeneratedMessages: VaultRegenerateData_RegeneratedMessage[];
};

/**
 * Describes the message domain.VaultRegenerateData.
 * Use `create(VaultRegenerateDataSchema)` to create a new message.
 */
export const VaultRegenerateDataSchema: GenMessage<VaultRegenerateData> = /*@__PURE__*/
  messageDesc(file_vault_service, 1);

/**
 * @generated from message domain.VaultRegenerateData.RegeneratedMessage
 */
export type VaultRegenerateData_RegeneratedMessage = Message<"domain.VaultRegenerateData.RegeneratedMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * NOTE: as backend_message is unencrypted, it does not need to be regenerated
   *
   * @generated from field: bytes encrypted_data = 2;
   */
  encryptedData: Uint8Array;
};

/**
 * Describes the message domain.VaultRegenerateData.RegeneratedMessage.
 * Use `create(VaultRegenerateData_RegeneratedMessageSchema)` to create a new message.
 */
export const VaultRegenerateData_RegeneratedMessageSchema: GenMessage<VaultRegenerateData_RegeneratedMessage> = /*@__PURE__*/
  messageDesc(file_vault_service, 1, 0);

/**
 * @generated from message domain.VaultCreationData
 */
export type VaultCreationData = Message<"domain.VaultCreationData"> & {
  /**
   * @generated from field: bytes first_commit_blob = 1;
   */
  firstCommitBlob: Uint8Array;

  /**
   * @generated from field: domain.VaultProfileLock profile_lock = 4;
   */
  profileLock?: VaultProfileLock | undefined;

  /**
   * NOTE: if organization_id is set, locks for the respective organization user must be included
   *
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;

  /**
   * @generated from field: bytes message_public_key = 5;
   */
  messagePublicKey: Uint8Array;

  /**
   * @generated from field: domain.VaultProfileLock admin_profile_lock = 6;
   */
  adminProfileLock?: VaultProfileLock | undefined;
};

/**
 * Describes the message domain.VaultCreationData.
 * Use `create(VaultCreationDataSchema)` to create a new message.
 */
export const VaultCreationDataSchema: GenMessage<VaultCreationData> = /*@__PURE__*/
  messageDesc(file_vault_service, 2);

/**
 * @generated from message domain.VaultPairCreationData
 */
export type VaultPairCreationData = Message<"domain.VaultPairCreationData"> & {
  /**
   * NOTE: The initial commit is assumed to be empty.
   *
   * @generated from field: bytes first_commit_blob = 1;
   */
  firstCommitBlob: Uint8Array;

  /**
   * @generated from field: domain.VaultProfileLock profile_lock = 7;
   */
  profileLock?: VaultProfileLock | undefined;

  /**
   * @generated from field: bytes message_public_key = 9;
   */
  messagePublicKey: Uint8Array;

  /**
   * @generated from field: domain.VaultProfileLock admin_profile_lock = 11;
   */
  adminProfileLock?: VaultProfileLock | undefined;

  /**
   * @generated from field: bytes associated_first_commit_blob = 4;
   */
  associatedFirstCommitBlob: Uint8Array;

  /**
   * @generated from field: domain.VaultProfileLock associated_profile_lock = 8;
   */
  associatedProfileLock?: VaultProfileLock | undefined;

  /**
   * @generated from field: bytes associated_message_public_key = 10;
   */
  associatedMessagePublicKey: Uint8Array;

  /**
   * @generated from field: domain.VaultProfileLock associated_admin_profile_lock = 12;
   */
  associatedAdminProfileLock?: VaultProfileLock | undefined;

  /**
   * NOTE: if organization_id is set, locks for the respective organization user must be included
   *
   * @generated from field: string organization_id = 6;
   */
  organizationId: string;
};

/**
 * Describes the message domain.VaultPairCreationData.
 * Use `create(VaultPairCreationDataSchema)` to create a new message.
 */
export const VaultPairCreationDataSchema: GenMessage<VaultPairCreationData> = /*@__PURE__*/
  messageDesc(file_vault_service, 3);

/**
 * @generated from message domain.ShareSecretUpdate
 */
export type ShareSecretUpdate = Message<"domain.ShareSecretUpdate"> & {
  /**
   * NOTE: this id is an uniuri, no uuid
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bytes encrypted_payload = 2;
   */
  encryptedPayload: Uint8Array;
};

/**
 * Describes the message domain.ShareSecretUpdate.
 * Use `create(ShareSecretUpdateSchema)` to create a new message.
 */
export const ShareSecretUpdateSchema: GenMessage<ShareSecretUpdate> = /*@__PURE__*/
  messageDesc(file_vault_service, 4);

/**
 * @generated from message domain.ShareSecretsDelete
 */
export type ShareSecretsDelete = Message<"domain.ShareSecretsDelete"> & {
  /**
   * Share links created in this vault not listed here will be deleted
   *
   * @generated from field: repeated string keep_share_secret_ids = 1;
   */
  keepShareSecretIds: string[];
};

/**
 * Describes the message domain.ShareSecretsDelete.
 * Use `create(ShareSecretsDeleteSchema)` to create a new message.
 */
export const ShareSecretsDeleteSchema: GenMessage<ShareSecretsDelete> = /*@__PURE__*/
  messageDesc(file_vault_service, 5);

/**
 * @generated from message domain.ShareLinkUpdate
 */
export type ShareLinkUpdate = Message<"domain.ShareLinkUpdate"> & {
  /**
   * NOTE: this id is an uniuri, no uuid
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * if empty, deletes the share link
   *
   * @generated from field: bytes encrypted_payload = 2;
   */
  encryptedPayload: Uint8Array;

  /**
   * @generated from field: bytes encrypted_protected_secret = 3;
   */
  encryptedProtectedSecret: Uint8Array;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message domain.ShareLinkUpdate.
 * Use `create(ShareLinkUpdateSchema)` to create a new message.
 */
export const ShareLinkUpdateSchema: GenMessage<ShareLinkUpdate> = /*@__PURE__*/
  messageDesc(file_vault_service, 6);

/**
 * @generated from message domain.ShareLinksDelete
 */
export type ShareLinksDelete = Message<"domain.ShareLinksDelete"> & {
  /**
   * Share links created in this vault not listed here will be deleted
   *
   * @generated from field: repeated string keep_share_link_ids = 1;
   */
  keepShareLinkIds: string[];
};

/**
 * Describes the message domain.ShareLinksDelete.
 * Use `create(ShareLinksDeleteSchema)` to create a new message.
 */
export const ShareLinksDeleteSchema: GenMessage<ShareLinksDelete> = /*@__PURE__*/
  messageDesc(file_vault_service, 7);

/**
 * @generated from message domain.CreateCommitRequest
 */
export type CreateCommitRequest = Message<"domain.CreateCommitRequest"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;

  /**
   * @generated from field: string latest_commit_id = 2;
   */
  latestCommitId: string;

  /**
   * @generated from field: bytes new_commit_blob = 3;
   */
  newCommitBlob: Uint8Array;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 4;
   */
  updateTime?: Timestamp | undefined;

  /**
   * @generated from field: repeated string delete_message_ids = 7;
   */
  deleteMessageIds: string[];

  /**
   * @generated from field: repeated domain.UpdateMessage update_messages = 8;
   */
  updateMessages: UpdateMessage[];

  /**
   * @generated from field: repeated domain.ShareLinkUpdate share_link_updates = 9;
   */
  shareLinkUpdates: ShareLinkUpdate[];

  /**
   * @generated from field: domain.ShareLinksDelete delete_share_links = 10;
   */
  deleteShareLinks?: ShareLinksDelete | undefined;

  /**
   * @generated from field: repeated domain.ShareSecretUpdate share_secret_updates = 12;
   */
  shareSecretUpdates: ShareSecretUpdate[];

  /**
   * @generated from field: domain.ShareSecretsDelete delete_share_secrets = 13;
   */
  deleteShareSecrets?: ShareSecretsDelete | undefined;

  /**
   * @generated from field: domain.LoginMaintenanceCriteria login_maintenance_criteria = 14;
   */
  loginMaintenanceCriteria?: LoginMaintenanceCriteria | undefined;
};

/**
 * Describes the message domain.CreateCommitRequest.
 * Use `create(CreateCommitRequestSchema)` to create a new message.
 */
export const CreateCommitRequestSchema: GenMessage<CreateCommitRequest> = /*@__PURE__*/
  messageDesc(file_vault_service, 8);

/**
 * @generated from message domain.CreateCommitResponse
 */
export type CreateCommitResponse = Message<"domain.CreateCommitResponse"> & {
  /**
   * @generated from field: string commit_id = 1;
   */
  commitId: string;

  /**
   * @generated from field: repeated string update_message_ids = 2;
   */
  updateMessageIds: string[];
};

/**
 * Describes the message domain.CreateCommitResponse.
 * Use `create(CreateCommitResponseSchema)` to create a new message.
 */
export const CreateCommitResponseSchema: GenMessage<CreateCommitResponse> = /*@__PURE__*/
  messageDesc(file_vault_service, 9);

/**
 * @generated from message domain.CreateGenerationRequest
 */
export type CreateGenerationRequest = Message<"domain.CreateGenerationRequest"> & {
  /**
   * @generated from field: domain.VaultRegenerateData vault = 1;
   */
  vault?: VaultRegenerateData | undefined;

  /**
   * @generated from field: repeated domain.UpdateMessage update_messages = 2;
   */
  updateMessages: UpdateMessage[];

  /**
   * @generated from field: domain.ShareLinksDelete delete_share_links = 3;
   */
  deleteShareLinks?: ShareLinksDelete | undefined;

  /**
   * @generated from field: repeated domain.ShareLinkUpdate share_link_updates = 4;
   */
  shareLinkUpdates: ShareLinkUpdate[];

  /**
   * @generated from field: domain.ShareSecretsDelete delete_share_secrets = 5;
   */
  deleteShareSecrets?: ShareSecretsDelete | undefined;

  /**
   * @generated from field: repeated domain.ShareSecretUpdate share_secret_updates = 6;
   */
  shareSecretUpdates: ShareSecretUpdate[];

  /**
   * @generated from field: domain.LoginMaintenanceCriteria login_maintenance_criteria = 14;
   */
  loginMaintenanceCriteria?: LoginMaintenanceCriteria | undefined;
};

/**
 * Describes the message domain.CreateGenerationRequest.
 * Use `create(CreateGenerationRequestSchema)` to create a new message.
 */
export const CreateGenerationRequestSchema: GenMessage<CreateGenerationRequest> = /*@__PURE__*/
  messageDesc(file_vault_service, 10);

/**
 * @generated from message domain.CreateGenerationResponse
 */
export type CreateGenerationResponse = Message<"domain.CreateGenerationResponse"> & {
  /**
   * Client do not use these individual ids anymore but they are still used in tests.
   *
   * @generated from field: string commit_id = 1;
   */
  commitId: string;

  /**
   * @generated from field: string generation_id = 2;
   */
  generationId: string;

  /**
   * @generated from field: domain.SyncUpdate sync_update = 3;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: repeated string update_message_ids = 4;
   */
  updateMessageIds: string[];
};

/**
 * Describes the message domain.CreateGenerationResponse.
 * Use `create(CreateGenerationResponseSchema)` to create a new message.
 */
export const CreateGenerationResponseSchema: GenMessage<CreateGenerationResponse> = /*@__PURE__*/
  messageDesc(file_vault_service, 11);

/**
 * @generated from message domain.ListCommitsRequest
 */
export type ListCommitsRequest = Message<"domain.ListCommitsRequest"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;

  /**
   * The last commit the client knows. Only commits created after this commit
   * are returned.
   *
   * @generated from field: google.protobuf.StringValue latest_commit_id = 2;
   */
  latestCommitId?: string | undefined;

  /**
   * The first commit of the generation the client knows. Sent as
   * a double-check, if it doesn't match the expected first commit the whole
   * generation will be returned.
   *
   * @generated from field: google.protobuf.StringValue latest_first_commit_id = 4;
   */
  latestFirstCommitId?: string | undefined;

  /**
   * locks are normally only returned when there is a new generation. set to always send
   *
   * @generated from field: bool force_locks = 3;
   */
  forceLocks: boolean;
};

/**
 * Describes the message domain.ListCommitsRequest.
 * Use `create(ListCommitsRequestSchema)` to create a new message.
 */
export const ListCommitsRequestSchema: GenMessage<ListCommitsRequest> = /*@__PURE__*/
  messageDesc(file_vault_service, 12);

/**
 * @generated from message domain.ListCommitsResponse
 */
export type ListCommitsResponse = Message<"domain.ListCommitsResponse"> & {
  /**
   * @generated from field: string current_generation_id = 1;
   */
  currentGenerationId: string;

  /**
   * @generated from field: repeated domain.ListCommitsResponse.Commit newer_commits = 2;
   */
  newerCommits: ListCommitsResponse_Commit[];

  /**
   * profile_lock, admin_profile_lock and message_public_key are only populated
   * if necessary (force_locks set or on new generation)
   *
   * @generated from field: domain.VaultProfileLock profile_lock = 6;
   */
  profileLock?: VaultProfileLock | undefined;

  /**
   * @generated from field: domain.VaultProfileLock admin_profile_lock = 8;
   */
  adminProfileLock?: VaultProfileLock | undefined;

  /**
   * @generated from field: bytes message_public_key = 10;
   */
  messagePublicKey: Uint8Array;

  /**
   * @generated from field: google.protobuf.Timestamp server_time = 4;
   */
  serverTime?: Timestamp | undefined;

  /**
   * @generated from field: string first_commit_id = 5;
   */
  firstCommitId: string;

  /**
   * @generated from field: repeated domain.ListCommitsResponse.Message messages = 7;
   */
  messages: ListCommitsResponse_Message[];

  /**
   * @generated from field: domain.LoginMaintenanceCriteria login_maintenance_criteria = 9;
   */
  loginMaintenanceCriteria?: LoginMaintenanceCriteria | undefined;
};

/**
 * Describes the message domain.ListCommitsResponse.
 * Use `create(ListCommitsResponseSchema)` to create a new message.
 */
export const ListCommitsResponseSchema: GenMessage<ListCommitsResponse> = /*@__PURE__*/
  messageDesc(file_vault_service, 13);

/**
 * @generated from message domain.ListCommitsResponse.Commit
 */
export type ListCommitsResponse_Commit = Message<"domain.ListCommitsResponse.Commit"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bytes blob = 2;
   */
  blob: Uint8Array;
};

/**
 * Describes the message domain.ListCommitsResponse.Commit.
 * Use `create(ListCommitsResponse_CommitSchema)` to create a new message.
 */
export const ListCommitsResponse_CommitSchema: GenMessage<ListCommitsResponse_Commit> = /*@__PURE__*/
  messageDesc(file_vault_service, 13, 0);

/**
 * @generated from message domain.ListCommitsResponse.Message
 */
export type ListCommitsResponse_Message = Message<"domain.ListCommitsResponse.Message"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: domain.VaultMessageType type = 2;
   */
  type: VaultMessageType;

  /**
   * @generated from field: bytes encrypted_data = 3;
   */
  encryptedData: Uint8Array;

  /**
   * @generated from field: string sender_vault_id = 4;
   */
  senderVaultId: string;

  /**
   * @generated from field: bytes backend_message = 5;
   */
  backendMessage: Uint8Array;
};

/**
 * Describes the message domain.ListCommitsResponse.Message.
 * Use `create(ListCommitsResponse_MessageSchema)` to create a new message.
 */
export const ListCommitsResponse_MessageSchema: GenMessage<ListCommitsResponse_Message> = /*@__PURE__*/
  messageDesc(file_vault_service, 13, 1);

/**
 * @generated from message domain.CreateTeamRequest
 */
export type CreateTeamRequest = Message<"domain.CreateTeamRequest"> & {
  /**
   * @generated from field: domain.VaultPairCreationData creation_data = 1;
   */
  creationData?: VaultPairCreationData | undefined;

  /**
   * @generated from field: domain.VaultMemberSyncMode member_sync_mode = 2;
   */
  memberSyncMode: VaultMemberSyncMode;

  /**
   * @generated from field: string entra_group_id = 3;
   */
  entraGroupId: string;
};

/**
 * Describes the message domain.CreateTeamRequest.
 * Use `create(CreateTeamRequestSchema)` to create a new message.
 */
export const CreateTeamRequestSchema: GenMessage<CreateTeamRequest> = /*@__PURE__*/
  messageDesc(file_vault_service, 14);

/**
 * @generated from message domain.CreateTeamResponse
 */
export type CreateTeamResponse = Message<"domain.CreateTeamResponse"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;

  /**
   * @generated from field: string associated_vault_id = 3;
   */
  associatedVaultId: string;

  /**
   * @generated from field: domain.SyncUpdate sync_update = 2;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.CreateTeamResponse.
 * Use `create(CreateTeamResponseSchema)` to create a new message.
 */
export const CreateTeamResponseSchema: GenMessage<CreateTeamResponse> = /*@__PURE__*/
  messageDesc(file_vault_service, 15);

/**
 * @generated from message domain.DeleteTeamRequest
 */
export type DeleteTeamRequest = Message<"domain.DeleteTeamRequest"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;
};

/**
 * Describes the message domain.DeleteTeamRequest.
 * Use `create(DeleteTeamRequestSchema)` to create a new message.
 */
export const DeleteTeamRequestSchema: GenMessage<DeleteTeamRequest> = /*@__PURE__*/
  messageDesc(file_vault_service, 16);

/**
 * @generated from message domain.DeleteTeamResponse
 */
export type DeleteTeamResponse = Message<"domain.DeleteTeamResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.DeleteTeamResponse.
 * Use `create(DeleteTeamResponseSchema)` to create a new message.
 */
export const DeleteTeamResponseSchema: GenMessage<DeleteTeamResponse> = /*@__PURE__*/
  messageDesc(file_vault_service, 17);

/**
 * @generated from message domain.UpdateVaultRequest
 */
export type UpdateVaultRequest = Message<"domain.UpdateVaultRequest"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;

  /**
   * @generated from field: domain.UpdateVaultRequest.VaultMemberSyncModeValue member_sync_mode = 2;
   */
  memberSyncMode?: UpdateVaultRequest_VaultMemberSyncModeValue | undefined;
};

/**
 * Describes the message domain.UpdateVaultRequest.
 * Use `create(UpdateVaultRequestSchema)` to create a new message.
 */
export const UpdateVaultRequestSchema: GenMessage<UpdateVaultRequest> = /*@__PURE__*/
  messageDesc(file_vault_service, 18);

/**
 * @generated from message domain.UpdateVaultRequest.VaultMemberSyncModeValue
 */
export type UpdateVaultRequest_VaultMemberSyncModeValue = Message<"domain.UpdateVaultRequest.VaultMemberSyncModeValue"> & {
  /**
   * @generated from field: domain.VaultMemberSyncMode value = 1;
   */
  value: VaultMemberSyncMode;
};

/**
 * Describes the message domain.UpdateVaultRequest.VaultMemberSyncModeValue.
 * Use `create(UpdateVaultRequest_VaultMemberSyncModeValueSchema)` to create a new message.
 */
export const UpdateVaultRequest_VaultMemberSyncModeValueSchema: GenMessage<UpdateVaultRequest_VaultMemberSyncModeValue> = /*@__PURE__*/
  messageDesc(file_vault_service, 18, 0);

/**
 * @generated from message domain.UpdateVaultResponse
 */
export type UpdateVaultResponse = Message<"domain.UpdateVaultResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.UpdateVaultResponse.
 * Use `create(UpdateVaultResponseSchema)` to create a new message.
 */
export const UpdateVaultResponseSchema: GenMessage<UpdateVaultResponse> = /*@__PURE__*/
  messageDesc(file_vault_service, 19);

/**
 * @generated from message domain.ModifyTeamUsersRequest
 */
export type ModifyTeamUsersRequest = Message<"domain.ModifyTeamUsersRequest"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;

  /**
   * @generated from field: repeated domain.ModifyTeamUsersRequest.AddProfileOperation add_profile_ops = 11;
   */
  addProfileOps: ModifyTeamUsersRequest_AddProfileOperation[];

  /**
   * @generated from field: repeated string remove_profile_ids = 12;
   */
  removeProfileIds: string[];

  /**
   * optional. if empty, removing users causes vaults to be flagged as dirty
   *
   * @generated from field: domain.VaultRegenerateData regenerate_data = 4;
   */
  regenerateData?: VaultRegenerateData | undefined;

  /**
   * @generated from field: domain.VaultRegenerateData associated_regenerate_data = 5;
   */
  associatedRegenerateData?: VaultRegenerateData | undefined;

  /**
   * optional. if supplied, creates a commit on the associated vault
   *
   * @generated from field: google.protobuf.Timestamp update_time = 6;
   */
  updateTime?: Timestamp | undefined;

  /**
   * @generated from field: string assoc_latest_commit_id = 7;
   */
  assocLatestCommitId: string;

  /**
   * @generated from field: bytes assoc_new_commit_blob = 8;
   */
  assocNewCommitBlob: Uint8Array;

  /**
   * checked to ensure locks are correctly associated
   *
   * @generated from field: string generation_id = 9;
   */
  generationId: string;

  /**
   * @generated from field: string assoc_generation_id = 10;
   */
  assocGenerationId: string;

  /**
   * optional. Used to determine if member sync is up to date (if applicable)
   *
   * @generated from field: google.protobuf.Timestamp member_sync_time = 13;
   */
  memberSyncTime?: Timestamp | undefined;
};

/**
 * Describes the message domain.ModifyTeamUsersRequest.
 * Use `create(ModifyTeamUsersRequestSchema)` to create a new message.
 */
export const ModifyTeamUsersRequestSchema: GenMessage<ModifyTeamUsersRequest> = /*@__PURE__*/
  messageDesc(file_vault_service, 20);

/**
 * @generated from message domain.ModifyTeamUsersRequest.AddProfileOperation
 */
export type ModifyTeamUsersRequest_AddProfileOperation = Message<"domain.ModifyTeamUsersRequest.AddProfileOperation"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;

  /**
   * @generated from field: domain.VaultProfileLock lock = 2;
   */
  lock?: VaultProfileLock | undefined;

  /**
   * @generated from field: domain.VaultProfileLock associated_lock = 3;
   */
  associatedLock?: VaultProfileLock | undefined;
};

/**
 * Describes the message domain.ModifyTeamUsersRequest.AddProfileOperation.
 * Use `create(ModifyTeamUsersRequest_AddProfileOperationSchema)` to create a new message.
 */
export const ModifyTeamUsersRequest_AddProfileOperationSchema: GenMessage<ModifyTeamUsersRequest_AddProfileOperation> = /*@__PURE__*/
  messageDesc(file_vault_service, 20, 0);

/**
 * @generated from message domain.ModifyTeamUsersResponse
 */
export type ModifyTeamUsersResponse = Message<"domain.ModifyTeamUsersResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.ModifyTeamUsersResponse.
 * Use `create(ModifyTeamUsersResponseSchema)` to create a new message.
 */
export const ModifyTeamUsersResponseSchema: GenMessage<ModifyTeamUsersResponse> = /*@__PURE__*/
  messageDesc(file_vault_service, 21);

/**
 * @generated from message domain.CreateInboxVaultRequest
 */
export type CreateInboxVaultRequest = Message<"domain.CreateInboxVaultRequest"> & {
  /**
   * @generated from field: domain.VaultPairCreationData creation_data = 1;
   */
  creationData?: VaultPairCreationData | undefined;

  /**
   * @generated from field: string metadata = 3;
   */
  metadata: string;
};

/**
 * Describes the message domain.CreateInboxVaultRequest.
 * Use `create(CreateInboxVaultRequestSchema)` to create a new message.
 */
export const CreateInboxVaultRequestSchema: GenMessage<CreateInboxVaultRequest> = /*@__PURE__*/
  messageDesc(file_vault_service, 22);

/**
 * @generated from message domain.CreateInboxVaultResponse
 */
export type CreateInboxVaultResponse = Message<"domain.CreateInboxVaultResponse"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;

  /**
   * @generated from field: string associated_vault_id = 3;
   */
  associatedVaultId: string;

  /**
   * @generated from field: domain.SyncUpdate sync_update = 2;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.CreateInboxVaultResponse.
 * Use `create(CreateInboxVaultResponseSchema)` to create a new message.
 */
export const CreateInboxVaultResponseSchema: GenMessage<CreateInboxVaultResponse> = /*@__PURE__*/
  messageDesc(file_vault_service, 23);

/**
 * @generated from message domain.UpdateInboxRequest
 */
export type UpdateInboxRequest = Message<"domain.UpdateInboxRequest"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;

  /**
   * @generated from field: google.protobuf.StringValue metadata = 3;
   */
  metadata?: string | undefined;

  /**
   * @generated from field: google.protobuf.BoolValue enabled = 5;
   */
  enabled?: boolean | undefined;
};

/**
 * Describes the message domain.UpdateInboxRequest.
 * Use `create(UpdateInboxRequestSchema)` to create a new message.
 */
export const UpdateInboxRequestSchema: GenMessage<UpdateInboxRequest> = /*@__PURE__*/
  messageDesc(file_vault_service, 24);

/**
 * @generated from message domain.UpdateInboxResponse
 */
export type UpdateInboxResponse = Message<"domain.UpdateInboxResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.UpdateInboxResponse.
 * Use `create(UpdateInboxResponseSchema)` to create a new message.
 */
export const UpdateInboxResponseSchema: GenMessage<UpdateInboxResponse> = /*@__PURE__*/
  messageDesc(file_vault_service, 25);

/**
 * @generated from message domain.DeleteInboxVaultRequest
 */
export type DeleteInboxVaultRequest = Message<"domain.DeleteInboxVaultRequest"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;
};

/**
 * Describes the message domain.DeleteInboxVaultRequest.
 * Use `create(DeleteInboxVaultRequestSchema)` to create a new message.
 */
export const DeleteInboxVaultRequestSchema: GenMessage<DeleteInboxVaultRequest> = /*@__PURE__*/
  messageDesc(file_vault_service, 26);

/**
 * @generated from message domain.DeleteInboxVaultResponse
 */
export type DeleteInboxVaultResponse = Message<"domain.DeleteInboxVaultResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.DeleteInboxVaultResponse.
 * Use `create(DeleteInboxVaultResponseSchema)` to create a new message.
 */
export const DeleteInboxVaultResponseSchema: GenMessage<DeleteInboxVaultResponse> = /*@__PURE__*/
  messageDesc(file_vault_service, 27);

/**
 * @generated from message domain.ListMessagePublicKeysRequest
 */
export type ListMessagePublicKeysRequest = Message<"domain.ListMessagePublicKeysRequest"> & {
  /**
   * limited to vaults of one particular organization, to keep permission check simple
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: repeated string vault_ids = 2;
   */
  vaultIds: string[];
};

/**
 * Describes the message domain.ListMessagePublicKeysRequest.
 * Use `create(ListMessagePublicKeysRequestSchema)` to create a new message.
 */
export const ListMessagePublicKeysRequestSchema: GenMessage<ListMessagePublicKeysRequest> = /*@__PURE__*/
  messageDesc(file_vault_service, 28);

/**
 * @generated from message domain.ListMessagePublicKeysResponse
 */
export type ListMessagePublicKeysResponse = Message<"domain.ListMessagePublicKeysResponse"> & {
  /**
   * this result is fail-slow: vaults that are not found will simply be missing here
   *
   * @generated from field: repeated domain.ListMessagePublicKeysResponse.MessagePublicKey message_public_keys = 1;
   */
  messagePublicKeys: ListMessagePublicKeysResponse_MessagePublicKey[];
};

/**
 * Describes the message domain.ListMessagePublicKeysResponse.
 * Use `create(ListMessagePublicKeysResponseSchema)` to create a new message.
 */
export const ListMessagePublicKeysResponseSchema: GenMessage<ListMessagePublicKeysResponse> = /*@__PURE__*/
  messageDesc(file_vault_service, 29);

/**
 * @generated from message domain.ListMessagePublicKeysResponse.MessagePublicKey
 */
export type ListMessagePublicKeysResponse_MessagePublicKey = Message<"domain.ListMessagePublicKeysResponse.MessagePublicKey"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;

  /**
   * @generated from field: string generation_id = 2;
   */
  generationId: string;

  /**
   * @generated from field: bytes key = 3;
   */
  key: Uint8Array;
};

/**
 * Describes the message domain.ListMessagePublicKeysResponse.MessagePublicKey.
 * Use `create(ListMessagePublicKeysResponse_MessagePublicKeySchema)` to create a new message.
 */
export const ListMessagePublicKeysResponse_MessagePublicKeySchema: GenMessage<ListMessagePublicKeysResponse_MessagePublicKey> = /*@__PURE__*/
  messageDesc(file_vault_service, 29, 0);

/**
 * @generated from message domain.GetVaultSyncMemberTargetStateRequest
 */
export type GetVaultSyncMemberTargetStateRequest = Message<"domain.GetVaultSyncMemberTargetStateRequest"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;
};

/**
 * Describes the message domain.GetVaultSyncMemberTargetStateRequest.
 * Use `create(GetVaultSyncMemberTargetStateRequestSchema)` to create a new message.
 */
export const GetVaultSyncMemberTargetStateRequestSchema: GenMessage<GetVaultSyncMemberTargetStateRequest> = /*@__PURE__*/
  messageDesc(file_vault_service, 30);

/**
 * @generated from message domain.GetVaultSyncMemberTargetStateResponse
 */
export type GetVaultSyncMemberTargetStateResponse = Message<"domain.GetVaultSyncMemberTargetStateResponse"> & {
  /**
   * @generated from field: repeated domain.GetVaultSyncMemberTargetStateResponse.Member members = 1;
   */
  members: GetVaultSyncMemberTargetStateResponse_Member[];

  /**
   * Time of the last sync with the source of truth (e.g. entra)
   * supplied by client on sync to determine if vault is up to date
   *
   * @generated from field: google.protobuf.Timestamp sync_time = 2;
   */
  syncTime?: Timestamp | undefined;

  /**
   * @generated from field: string vault_name = 3;
   */
  vaultName: string;
};

/**
 * Describes the message domain.GetVaultSyncMemberTargetStateResponse.
 * Use `create(GetVaultSyncMemberTargetStateResponseSchema)` to create a new message.
 */
export const GetVaultSyncMemberTargetStateResponseSchema: GenMessage<GetVaultSyncMemberTargetStateResponse> = /*@__PURE__*/
  messageDesc(file_vault_service, 31);

/**
 * @generated from message domain.GetVaultSyncMemberTargetStateResponse.Member
 */
export type GetVaultSyncMemberTargetStateResponse_Member = Message<"domain.GetVaultSyncMemberTargetStateResponse.Member"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;

  /**
   * @generated from field: domain.VaultPermissionLevel default_permission = 2;
   */
  defaultPermission: VaultPermissionLevel;

  /**
   * @generated from field: repeated domain.VaultPermissionLevel allowed_permissions = 3;
   */
  allowedPermissions: VaultPermissionLevel[];
};

/**
 * Describes the message domain.GetVaultSyncMemberTargetStateResponse.Member.
 * Use `create(GetVaultSyncMemberTargetStateResponse_MemberSchema)` to create a new message.
 */
export const GetVaultSyncMemberTargetStateResponse_MemberSchema: GenMessage<GetVaultSyncMemberTargetStateResponse_Member> = /*@__PURE__*/
  messageDesc(file_vault_service, 31, 0);

/**
 * @generated from service domain.VaultService
 */
export const VaultService: GenService<{
  /**
   * errors:
   * - BadRequest (10400): trying to update share link from another vault
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - VaultNotFound (50400)
   * - InvalidUpdateTime (50430): invalid update time
   * - MalformedLoginMaintenanceCriteria(50432): login maintenance criteria are not valid json
   * - VaultDirty (50450): vault needs to be regenerated before commit can be made (is flagged dirty)
   * - EmptyCommit (50200): commit blob is empty
   * - PermissionDenied (10100): insufficient permissions
   * - VaultOutOfSync (50100): latest_commit_id does not match, or generation_id of message does not match
   * - NotAllowedForVault (50110): target vault of vault message not valid
   * - MissingVaultMessagePublicKey (50461): the vault has no message public key, but it is required for the operation
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.VaultService.CreateCommit
   */
  createCommit: {
    methodKind: "unary";
    input: typeof CreateCommitRequestSchema;
    output: typeof CreateCommitResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - VaultNotFound (50400)
   * - EmptyCommit (50200)
   * - MalformedLoginMaintenanceCriteria(50432)
   * - PermissionDenied (10100)
   * - VaultOutOfSync (50100)
   * - NotAllowedForVault (50110): target vault of vault message not valid
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.VaultService.CreateGeneration
   */
  createGeneration: {
    methodKind: "unary";
    input: typeof CreateGenerationRequestSchema;
    output: typeof CreateGenerationResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - VaultNotFound (50400): vault not found
   * - PermissionDenied (10100): insufficient permissions
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.VaultService.ListCommits
   */
  listCommits: {
    methodKind: "unary";
    input: typeof ListCommitsRequestSchema;
    output: typeof ListCommitsResponseSchema;
  },
  /**
   * Create creates a new vault for the authenticated user. The vault is assumed to be empty on creation.
   * errors:
   * - BadRequest (10400): MemberSyncMode or EntraGroupId not applicable
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - UserNotFound (20400): user not found
   * - MissingVaultProfileLock (50411): missing vault profile lock
   * - ConflictingVaultExists (50401): a conflicting vault already exists (e.g. org already has an "all users" vault)
   * - InvalidVaultType (50431): given vault types are not allowed
   * - OrganizationInsufficientAccess (60100): user may not create team in specified organization
   * - OrganizationNotFound (60400): organization does not exist or user is not a member
   * - IntegrationGroupNotFound (80403)
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.VaultService.CreateTeam
   */
  createTeam: {
    methodKind: "unary";
    input: typeof CreateTeamRequestSchema;
    output: typeof CreateTeamResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - VaultNotFound (50400): vault not found
   * - PermissionDenied (10100): insufficient permissions
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.VaultService.DeleteTeam
   */
  deleteTeam: {
    methodKind: "unary";
    input: typeof DeleteTeamRequestSchema;
    output: typeof DeleteTeamResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - VaultNotFound (50400): vault not found
   * - PermissionDenied (10100): insufficient permissions
   * - NotAllowedForVault (50110): vault is no team or setting a setting not applicable
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.VaultService.Update
   */
  update: {
    methodKind: "unary";
    input: typeof UpdateVaultRequestSchema;
    output: typeof UpdateVaultResponseSchema;
  },
  /**
   * errors:
   * - UserNotFound (20400): one of the users to add was not found
   * - NotAllowedForUserType (20470): tried to add/remove an organization user
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - NotAllowedForVault (50110): tried to change users on a personal vault
   * - VaultNotFound (50400): vault not found or associated vault id does not match
   * - EmptyCommit (50200): commit blob is empty
   * - InvalidUpdateTime (50430): invalid update time
   * - VaultOutOfSync (50100): latest_commit_id, generation_id or assoc_generation_id does not match
   * - MissingLock (50410): a lock is missing for regneration or no keks were provided for a new authenticator
   * - MissingVault (50420): missing associated regenerate data
   * - VaultMemberSyncOutdated (50472): the vault member sync data used is outdated
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.VaultService.ModifyTeamUsers
   */
  modifyTeamUsers: {
    methodKind: "unary";
    input: typeof ModifyTeamUsersRequestSchema;
    output: typeof ModifyTeamUsersResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - MissingVault (50420): missing VaultPairCreationData
   * - MissingEncryptedVaultMessagePrivateKey (50460): a lock is missing the encrypted private key
   * - MissingVaultMessagePublicKey (50461): no message public key was provided
   * - VaultInboxSlugInvalid (50470): the inbox slug is invalid
   * - VaultInboxSlugTaken (50471): the inbox slug is already in use
   * - OrganizationInsufficientAccess (60100): not allowed to create vaults in organization
   * - OrganizationNotFound (60400): organization not found or no access
   * - ProfileNotFound (70400): the profile was not found for the user
   * - ProfileOutOfSync (70411): ProfileLock does not have curren KeyGenerationId
   * - Internal (10500)
   *
   * @generated from rpc domain.VaultService.CreateInboxVault
   */
  createInboxVault: {
    methodKind: "unary";
    input: typeof CreateInboxVaultRequestSchema;
    output: typeof CreateInboxVaultResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - PermissionDenied (10100): no access to the vault
   * - EmailRequired (20103): trying to enable inbox with unverified email
   * - NotAllowedForVault (50110): specified vault is not an inbox Vault
   * - VaultInboxSlugInvalid (50470)
   * - VaultInboxSlugTaken (50471)
   * - Internal (10500)
   *
   * @generated from rpc domain.VaultService.UpdateInbox
   */
  updateInbox: {
    methodKind: "unary";
    input: typeof UpdateInboxRequestSchema;
    output: typeof UpdateInboxResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - VaultNotFound (50400)
   * - NotAllowedForVault (50110): specified vault is not an inbox Vault
   * - PermissionDenied (10100): no access to the vault
   * - Internal (10500)
   *
   * @generated from rpc domain.VaultService.DeleteInboxVault
   */
  deleteInboxVault: {
    methodKind: "unary";
    input: typeof DeleteInboxVaultRequestSchema;
    output: typeof DeleteInboxVaultResponseSchema;
  },
  /**
   * Note this method does not throw VaultNotFound.
   * Missing vaults will just be missing from the result.
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400)
   * - Internal (10500)
   *
   * @generated from rpc domain.VaultService.ListMessagePublicKeys
   */
  listMessagePublicKeys: {
    methodKind: "unary";
    input: typeof ListMessagePublicKeysRequestSchema;
    output: typeof ListMessagePublicKeysResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - PermissionDenied (10100)
   * - VaultNotFound (50400)
   * - NotAllowedForVault (50110): specified vault has no organization or applicable VaultMemberSyncMode
   * - IntegrationGroupNotFound (80500): the group the vault is synced to was not found
   * - Internal (10500)
   *
   * @generated from rpc domain.VaultService.GetSyncMemberTargetState
   */
  getSyncMemberTargetState: {
    methodKind: "unary";
    input: typeof GetVaultSyncMemberTargetStateRequestSchema;
    output: typeof GetVaultSyncMemberTargetStateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_vault_service, 0);

